/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Advanced forms icon.
 */
export const ICON_CAPABILITY_ADVANCED_FORMS = (
  <svg fill="none" height="48" viewBox="0 0 48 48" width="48" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 10C13.5817 10 10 13.5817 10 18V30C10 34.4183 13.5817 38 18 38H30C34.4183 38 38 34.4183 38 30V18.3798L24.3569 32.0384C23.5848 32.8105 22.3374 32.8105 21.5652 32.0384L14.4573 24.9304C14.0865 24.5605 13.8782 24.0583 13.8782 23.5346C13.8782 23.0109 14.0865 22.5087 14.4573 22.1387C15.2295 21.3666 16.4768 21.3666 17.249 22.1387L22.9512 27.8409L36.8788 13.9133C35.4837 11.57 32.9252 10 30 10H18Z"
      fill="#1D9BE2"
    />
    <path
      clipRule="evenodd"
      d="M15.5032 7.01172C10.8088 7.01172 7.00317 10.8173 7.00317 15.5117V20.316C7.00317 21.1444 6.3316 21.816 5.50317 21.816C4.67475 21.816 4.00317 21.1444 4.00317 20.316V15.5117C4.00317 9.16045 9.1519 4.01172 15.5032 4.01172H32.5139C38.8652 4.01172 44.0139 9.16045 44.0139 15.5117V20.316C44.0139 21.1444 43.3423 21.816 42.5139 21.816C41.6855 21.816 41.0139 21.1444 41.0139 20.316V15.5117C41.0139 10.8173 37.2083 7.01172 32.5139 7.01172H15.5032Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M15.5032 41.0225C10.8088 41.0225 7.00317 37.2169 7.00317 32.5225V29.5687C7.00317 28.7403 6.3316 28.0687 5.50317 28.0687C4.67475 28.0687 4.00317 28.7403 4.00317 29.5687V32.5225C4.00317 38.8737 9.1519 44.0225 15.5032 44.0225H32.5139C38.8652 44.0225 44.0139 38.8737 44.0139 32.5225V29.5687C44.0139 28.7403 43.3423 28.0687 42.5139 28.0687C41.6855 28.0687 41.0139 28.7403 41.0139 29.5687V32.5225C41.0139 37.2169 37.2083 41.0225 32.5139 41.0225H15.5032Z"
      fill="#1D9BE2"
      fillRule="evenodd"
    />
  </svg>
);
